import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-01 «Вільні гроші». Тека с этим файлом — и есть
// регистрация. Вход — с дашборда и пунктом меню у пресетов, которым поверхность
// выдана (`docs/SCREEN-MAP.md`, `S-01`, «Вхід»).
export const meta: SurfaceMeta = {
  code: "S-01",
  // Название — слово словаря по коду (`G117`, таск 74), читается при показе.
  get title_uk() {
    return w("s01_title");
  },
  path: "/s-01",
};
